import React from 'react';
import style from './Trails.module.scss';
import trailImg from '../imgs/trail.jpg';

const STOPS = [
    { n: '1', title: 'Whale Cave', meta: '2:40 · Indigenous' },
    { n: '2', title: 'Day in the life of a Mining Family', meta: '3:15 · Personal stories' },
    { n: '3', title: 'Mt Kembla disaster', meta: '1:58 · Major Events' },
    { n: '4', title: "Mary's Monkey", meta: '4:02 · Military' },
];

const Trails = () => (
    <section className={style.trailsSection} id="trails">
        <div className={`wrap ${style.trailsInner}`}>
            <div>
                <div className="eyebrow" style={{ color: 'var(--brass)' }}>On the ground</div>
                <h2>Some stories are worth following on foot.</h2>
                <p className={style.trailsCopy}>A trail strings a handful of nearby stories into a single walking route. Follow the pins from stop to stop and a neighbourhood's history unfolds the way it actually happened — one street, one doorway, one story at a time. Open a trail when you're nearby and let it lead the way.</p>
                <div className={style.trailStats}>
                    <div className={style.trailStat}><b>4–7</b><span>stops per trail</span></div>
                    <div className={style.trailStat}><b>~2–6 km</b><span>typical length</span></div>
                    <div className={style.trailStat}><b>On foot/Driving/Cycling</b><span>self-guided, any pace</span></div>
                </div>
                <a href="#about" className={style.btnPrimary}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="4" cy="10.5" r="2" stroke="#101B29" strokeWidth="1.3" /><circle cx="10.5" cy="3.5" r="2" stroke="#101B29" strokeWidth="1.3" /><path d="M5.4 9 9 4.9" stroke="#101B29" strokeWidth="1.3" strokeLinecap="round" strokeDasharray="0.2 2.4" /></svg>
                    Find a trail near you
                </a>
            </div>
            <div className={style.trailCard}>
                <div className={style.trailCardHead}>
                    <div className={style.trailCardEyebrow}>Featured trail</div>
                    <h4>The Mount Kembla Trail</h4>
                    <p>7 stops · 6 km · about 60 min on foot</p>
                </div>
                <div className={style.trailCardBody}>
                    <div className={style.trailPath}>
                        {STOPS.map(stop => (
                            <div className={style.trailStop} key={stop.n}>
                                <div className={style.dot}>{stop.n}</div>
                                <div className={style.stopInfo}><b>{stop.title}</b><span>{stop.meta}</span></div>
                            </div>
                        ))}
                        <div className={`${style.trailStop} ${style.more}`}>
                            <div className={style.dot}>···</div>
                            <div className={style.stopInfo}><b>3 more stops</b><span>about 30 min further on</span></div>
                        </div>
                    </div>
                    <div className={style.trailDiagram}><img src={trailImg} alt="The Mount Kembla Trail in the Yesterday Stories app" /></div>
                </div>
            </div>
        </div>
    </section>
);

export default Trails;
